export const MARGIN_CONTENT = 300;
